import React from 'react';
import Icon from '../Icon';
import svg from '../icons/new-window.js';

const IconNewWindow = (props) => <Icon {...props} svg={svg} />;

IconNewWindow.displayName = 'IconNewWindow';

export default IconNewWindow;
